<template>
  <b-container fluid class="bg-light-gray h-100 pt-4">
    <b-jumbotron class="shadow p-5 bg-white rounded mx-auto my-auto w-50 text-center">
      <h3 class="my-2">Your account has been locked for breach of testing rules.</h3>
      Please contact your supervisor for assistance.
    </b-jumbotron>
  </b-container>
</template>

<script>
export default {
  name: "ExamineeLocked",
  methods: {
  
  },
};
</script>

<style lang="css" scoped>
.termsAndConditionContainer {
  overflow-y: scroll;
  height: 350px;
}
</style>